import React, { useEffect, useState } from 'react';
import ResultLink from '../ResultLink';
import { unitConversion } from '../../helpers';

export const CommunitySliderCard = props => {
  const { result, distanceUnit, isNearby } = props;

  return (
    <>
      {isNearby ? (
        <ResultLink
          result={result}
          className="nearby-communities-row-headless__item"
        >
          <div className="nearby-communities-row-headless__picture-wrapper">
            <div className="nearby-communities-row-headless__item-image">
              <img src={result.raw.ssl_mainimagedesktop} alt={result.title} />
            </div>
            <div className="nearby-communities-row-headless__item-image-active">
              <img
                src={result.raw.ssl_mainimagedesktop_405x548}
                alt={result.title}
              ></img>
            </div>
          </div>
          <div className="nearby-communities-row-headless__info">
            <div className="nearby-communities-row-headless__content">
              <h3 className="nearby-communities-row-headless__content-heading">
                <span>{result.raw.ssl_communityname}</span>
              </h3>
              {result.raw.ssl_levelsofcare &&
                result.raw.ssl_levelsofcare.length > 0 && (
                  <ul>
                    {result.raw.ssl_levelsofcare.map((level, index) => (
                      <li key={index}>{level}</li>
                    ))}
                    {result.raw.ssl_communityprice && result.raw.ssl_communityprice.length > 0 && (
                      <li className="nearby-communities-row-headless__price">Room rates start at {result.raw.ssl_communityprice} /month</li>
                    )}
                  </ul>
                )}
            </div>
            <span className="nearby-communities-row-headless__link">
              <span className="link__label">Learn More</span>
              <svg
                viewBox="0 0 11 18"
                width="7"
                height="17"
                role="presentation"
              >
                <use xlinkHref="#arrow-right"></use>
              </svg>
            </span>
            <span className="nearby-communities-row-headless__distance">
              <span>
                {unitConversion(result.raw.distance, distanceUnit)}{' '}
                {distanceUnit.toUpperCase()}
              </span>
            </span>
          </div>
          <div className="nearby-communities-row-headless__slide-overlay"></div>
        </ResultLink>
      ) : (
        <ResultLink result={result} className="community-row__item">
          <div className="community-row__picture-wrapper">
            <div className="community-row__item-image">
              <img src={result.raw.ssl_mainimagedesktop} alt={result.title} />
            </div>
            <div className="community-row__item-image-active">
              <img
                src={result.raw.ssl_mainimagedesktop_405x548}
                alt={result.title}
              ></img>
            </div>
          </div>
          <div className="community-row__info">
            <div className="community-row__content">
              <h3 className="community-row__heading">
                <span>{result.raw.ssl_communityname}</span>
              </h3>
              {result.raw.ssl_levelsofcare &&
                result.raw.ssl_levelsofcare.length > 0 && (
                  <ul>
                    {result.raw.ssl_levelsofcare.map((level, index) => (
                      <li key={index}>{level}</li>
                    ))}
                    {result.raw.ssl_communityprice && result.raw.ssl_communityprice.length > 0 && (
                      <li className="nearby-communities-row-headless__price">Room rates start at {result.raw.ssl_communityprice} /month</li>
                    )}
                  </ul>
                )}
            </div>
            <span className="community-row__link">
              <span className="link__label">Learn More</span>
              <svg
                viewBox="0 0 11 18"
                width="7"
                height="17"
                role="presentation"
              >
                <use xlinkHref="#arrow-right"></use>
              </svg>
            </span>
            <span className="community-row__distance">
              <span>
                {unitConversion(result.raw.distance, distanceUnit)}{' '}
                {distanceUnit.toUpperCase()}
              </span>
            </span>
          </div>
        </ResultLink>
      )}
    </>
  );
};

export default CommunitySliderCard;
